<template>
	<div>
		<b-container fluid class="margin-top-header">
			<v-section-white>
				<b-col cols="12" md="10" offset-md="1" >
					<h1 class="text-macal text-center mt-4"><b>¡Pronto estaremos en contacto!</b></h1>
					<h4 class="mt-4 pl-2 text-macal border-bottom-macal">¡Los ejecutivos de entidad financiera esán analizando y adaptando tu solicitud!</h4>
					<p class="p-4">Debemos hacer pequeños ajustes a las condiciones de tu crédito. No te preocupes, te contactaremos dentro de la próxima hora (horario hábil) para entregarte una propuesta</p>
					<b-row>
						<b-col cols="12" class="text-center mt-5">
							<p>¡Recuerda abonar tu garantía por el vehículo que elijas!</p>
							<b-button size="lg" class="my-3 pl-5 pr-5" variant="outline-macal" @click="backToFront" >Ver oferta vehículos</b-button>
							<p><small>Cualquier duda o consulta a <a href="mailto:financiamiento@macal.cl">financiamiento@macal.cl</a></small></p>
						</b-col>
					</b-row>
				</b-col>
			</v-section-white>
		</b-container>
	</div>
</template>
<script>
  import SectionWhite from "../../../components/section-white";
  export default {
    name: 'financing-pending',
    components: {
		'v-section-white': SectionWhite,
	},
	props: {
        customer:{
            rut: {default: null},
            name: {default: null},
            lastnameFather: {default: null},
            lastnameMother: {default: null},
            phone: {default: null},
            email: {default: null},
            rent: {default: null},
            amount: {default: null},
            foot: {default: null},
            contact: {default: null}
		}
	},
	data (){
		return{
		}
	},
	mounted() {
	},
	methods:{
		backToFront(){
			this.$router.push({ name: 'vehicles-buy', params: {customer: this.customer}});
		},
	},
	watch: {
	}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>